import React, { useEffect, useState } from "react";
import style from "../../../../assets/styles/userManagement.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  EdituserDetails,
  GetRoles,
  GetUserDetail,
  getUserQuestionBank,
  UserScreenChange,
} from "../../../../redux/action";

const EditUser = () => {
  const { userDataInfo } = useSelector((state) => state.GetAllData);
  const dispatch = useDispatch();

  const [userName, setUserName] = useState(userDataInfo?.name);
  const [userEmail, setUserEmail] = useState(userDataInfo?.email_id);
  const [userPhone, setUserPhone] = useState(userDataInfo?.mobile_number);
  const [userRoles, setUserRoles] = useState(userDataInfo?.roles);
  const [userOrganisation, setUserOrganisation] = useState(
    userDataInfo?.organization
  );
  const [userQuestionBank, setUserQuestionBank] = useState(
    userDataInfo?.question_bank_management
  );
  const [userIs_active, setUserIs_active] = useState(userDataInfo?.is_active);

  // _________ GET QUESTION BANK API CALL SAVED THE DATA IN STATE _________
  const { questionBank } = useSelector((state) => state.GetAllData);

  useEffect(() => {
    dispatch(getUserQuestionBank());
  }, []);

  // QUESTION BANK ADD for updating the user
  const QuestionBankAdd = (e, selection, event) => {
    if (event.target.checked) {
      if (userQuestionBank.some((items, i) => items.id === e.id)) {
        const foundItem = userQuestionBank.find((item) => item.id === e.id);
        if (foundItem) {
          foundItem[selection] = true;
        }
        setUserQuestionBank(userQuestionBank);
        setQuestionBankAll(QuestionBankAll);
      } else {
        setUserQuestionBank((current) => [
          ...current,
          {
            name: e.name,
            id: e.id,
            question_bank: 1,
            review: selection === "review" ? true : false,
            edit: selection === "edit" ? true : false,
            view: selection === "view" ? true : false,
            thin_file: selection === "thin_file" ? true : false,
          },
        ]);

        setQuestionBankAll((current) => [
          ...current,
          {
            name: e.name,
            id: e.id,
            question_bank: 1,
            review: selection === "review" ? true : false,
            edit: selection === "edit" ? true : false,
            view: selection === "view" ? true : false,
            thin_file: selection === "thin_file" ? true : false,
            discription: e.discription,
            total_questions: e.total_questions,
            free_tags: e.free_tags,
          },
        ]);
      }
    } else {
      const indexToRemove = userQuestionBank.findIndex(
        (item) => item.id === e.id
      );
      const indexToRemove2 = QuestionBankAll.findIndex(
        (item) => item.id === e.id
      );
      if (indexToRemove !== -1) {
        userQuestionBank.splice(indexToRemove, 1);
      }
      if (indexToRemove2 !== -1) {
        QuestionBankAll.splice(indexToRemove, 1);
      }
    }
  };

  // _______________ roles get ______________
  const { roles } = useSelector((state) => state.GetAllData);

  // _______ add roles _______
  const AddRoles = (e) => {
    setUserRoles((current) => [...current, Number(e)]);
  };

  // _______  remove user role ______
  const RomeveUserRoles = (e) => {
    const filteredUserroles = userRoles.filter((id) => id !== e.id);
    setUserRoles(filteredUserroles);
  };

  // ___________ oganisation _____________
  const { organisationList } = useSelector((state) => state.GetAllData);

  // ____________ body for updating user ________
  const body = {
    name: userName,
    email_id: userEmail,
    mobile_number: userPhone,
    roles: userRoles,
    organization: userOrganisation,
    is_active: userIs_active,
    question_bank_management: userQuestionBank,
  };

 
  // Question bank all for displaying all the question bank
  const [QuestionBankAll, setQuestionBankAll] = useState([]);

  useEffect(() => {
    const mappedArray = questionBank?.map((item1) => {
      const matchingItem2 = userQuestionBank?.find(
        (item2) => item2.id === item1.id
      );

      // If there is a match, combine the properties from both arrays
      if (matchingItem2) {
        return {
          ...item1,
          ...matchingItem2,
        };
      }

      // If no match found, return the original item1
      return item1;
    });

    setQuestionBankAll(mappedArray);
  }, [questionBank, userQuestionBank, QuestionBankAll]);

  return (
    <div>
      <div className={style.top_section}>
        <span
          className={style.left}
          onClick={() => dispatch(UserScreenChange(2))}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.5488 19.422L9.02883 12.902C8.25883 12.132 8.25883 10.872 9.02883 10.102L15.5488 3.58203"
              stroke="#212529"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Back
        </span>
      </div>

      <div className={style.table_content_report}>
        <div
          className={` ${style.top_content_table} ${style.profile_title_div}`}
        >
          User Profile
        </div>

        {/* TABLE LISTING OF ALL AND MY QUESTION  */}
        <div className={style.user_profile}>
          <div className={style.tags}>
            <div className={style.subject}>
              <p>Full Name </p>
              <input
                className={style.input_search}
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                type="search"
                id="searchInput"
                placeholder="Enter your full name"
              />
            </div>
            <div className={style.subject}>
              <p>Email ID </p>
              <input
                type="search"
                className={style.input_search}
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                id="searchInput"
                placeholder="Enter your Email ID"
              />
            </div>
          </div>
        </div>

        <div className={style.user_profile}>
          <div className={style.tags}>
            <div className={style.subject}>
              <p>Mobile Number </p>
              <input
                className={style.input_search}
                onChange={(e) => setUserPhone(Number(e.target.value))}
                value={userPhone}
                type="search"
                id="searchInput"
                placeholder="Enter your mobile number"
              />
            </div>
            <div className={style.subject}>
              <p>Roles </p>
              <select
                className={style.dropdown_css}
                id="searchInput"
                placeholder="Select your roles"
                name="cars"
                onChange={(e) => AddRoles(e.target.value)}
              >
                {/* <option disabled>--------- select Roles-----------</option> */}
                {roles
                  ?.filter((item) => !userRoles?.includes(item.id))
                  ?.map((items, i) => (
                    <option value={items.id}>{items.name}</option>
                  ))}
              </select>
              {roles
                ?.filter((item) => userRoles?.includes(item.id))
                .map((items, i) => (
                  <span className={style.roleBox}>
                    {items.name}
                    <span onClick={() => RomeveUserRoles(items)}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.34375 6.34375L17.6575 17.6575"
                          stroke="#272727"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.34254 17.6575L17.6562 6.34375"
                          stroke="#272727"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </span>
                ))}
            </div>
          </div>
        </div>

        <div className={style.user_profile}>
          <div className={style.tags}>
            <div className={style.subject}>
              <p>Organisation </p>
              <select
                className={style.dropdown_css}
                id="searchInput"
                placeholder="Select your roles"
                name="cars"
                onChange={(e) => setUserOrganisation(Number(e.target.value))}
              >
                {organisationList?.map((items, i) => (
                  <option value={items.id}>{items.name}</option>
                ))}
              </select>{" "}
              {organisationList
                ?.filter((item) => item.id == userOrganisation)
                .map((items, i) => (
                  <span className={style.roleBox}>{items.name}</span>
                ))}
            </div>
          </div>
        </div>

        <div className={` ${style.select_question} ${style.profile_status}`}>
          <div className={style.info}>
            {/* format  */}
            <div className={style.format}>
              <div className={style.format_title}>
                Status <b className={style.red_mendantory}>*</b>
              </div>
              <div className={style.format_choice}>
                <div>
                  <input
                    type="radio"
                    className={style.pointer}
                    checked={userIs_active ? true : false}
                    onClick={() => setUserIs_active(true)}
                    id="question"
                    name="choose_question"
                    value="Question"
                  />
                  <label for="html">Active</label>
                </div>
                <div>
                  <input
                    type="radio"
                    className={style.pointer}
                    checked={userIs_active ? false : true}
                    onClick={() => setUserIs_active(false)}
                    id="question"
                    name="choose_question"
                    value="Question"
                  />
                  <label for="html">Inactive</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={` ${style.select_question} ${style.profile_status}`}>
          <div className={style.title}>Question Bank management</div>

          <div className={style.question_bank_table}>
            <div className={style.thead_question_bank}>
              <div className={style.first}>Question Bank</div>
              <div className={style.second}>Review</div>
              <div className={style.third}>Edit</div>
              <div className={style.fouth}>View</div>
              <div className={style.last}>Thin File</div>
            </div>

 
            {QuestionBankAll?.map((items, i) => (
              <div className={style.tbody_question_bank}>
                <div className={style.first}>{items.name}</div>
                <div className={style.second}>
                  <input
                    type="checkbox"
                    checked={items.review}
                    onClick={(e) => QuestionBankAdd(items, "review", e)}
                  />
                </div>
                <div className={style.third}>
                  <input
                    type="checkbox"
                    checked={items.edit}
                    onClick={(e) => QuestionBankAdd(items, "edit", e)}
                  />
                </div>
                <div className={style.fouth}>
                  <input
                    type="checkbox"
                    checked={items.view}
                    onClick={(e) => QuestionBankAdd(items, "view", e)}
                  />
                </div>
                <div className={style.last}>
                  <input
                    type="checkbox"
                    checked={items.thin_file}
                    onClick={(e) => QuestionBankAdd(items, "thin_file", e)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className={` ${style.saveButton_questionBank} ${style.margin_top_20}`}
      >
        <div
          className={` ${style.cancel} ${style.pointer}`}
          onClick={() => dispatch(UserScreenChange(0))}
        >
          Cancel
        </div>
        <div>
          <button className={style.blue_button} onClick={() => dispatch(EdituserDetails(userDataInfo.id, body))}>
            Update User
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
